import React from 'react'

const ChooseUs = () => {
    return (
        <>
            <div className="why-choose-us" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6">
                            {/* Why Choose Us Content Start */}
                            <div className="why-choose-us-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <span className="section-sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Why Choose Us</span>
                                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Expert driven solar solutions built for efficiency & trust" style={{ perspective: 400 }}>
                                        <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                                            <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                                Why Choose Solar World Enterprises?
                                            </div>
                                        </div>
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' , textAlign:"justify"}}>At Solar World Enterprises, we are committed to providing reliable, efficient, and sustainable solar energy solutions that help our customers reduce energy costs and move towards a cleaner future. Our customer-focused approach, quality products, and professional services make us a trusted choice for solar energy solutions.</p>
                                </div>
                                {/* Section Title End */}
                                {/* Why Choose Item Start */}
                                <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="icon-box">
                                        <img src="./assets/images/icon-why-choose-us-item.svg" alt />
                                    </div>
                                    <div className="why-choose-item-content">
                                        <h3>Quality & Reliable Solar Solutions</h3>
                                        <p>We provide dependable solar energy solutions designed to deliver efficient performance, durability, and long-term value.</p>
                                    </div>
                                </div>
                                {/* Why Choose Item End */}
                                {/* Why Choose Counter List Start */}
                                <div className="why-choose-counter-list wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    {/* Why Choose Counter Item Start */}
                                    <div className="why-choose-counter-item">
                                        <h2><span className="counter">600</span>+</h2>
                                        <p>Solar Installations</p>
                                    </div>
                                    {/* Why Choose Counter Item End */}
                                    {/* Why Choose Counter Item Start */}
                                    <div className="why-choose-counter-item">
                                        <h2><span className="counter">05</span>+</h2>
                                        <p>Experts Staff</p>
                                    </div>
                                    {/* Why Choose Counter Item End */}
                                    {/* Why Choose Counter Item Start */}
                                    <div className="why-choose-counter-item">
                                        <h2><span className="counter">06</span>+</h2>
                                        <p>Our Award recognitions</p>
                                    </div>
                                    {/* Why Choose Counter Item End */}
                                </div>
                                {/* Why Choose Counter List End */}
                                {/* Why Choose Buton Start */}

                                {/* Why Choose Buton End */}
                            </div>
                            {/* Why Choose Us Content End */}
                        </div>
                        <div className="col-xl-6">
                            {/* Why Choose Us Image Box Start */}
                            <div className="why-choose-us-image-box">
                                {/* Why Choose Image Box 1 Start */}
                                <div className="why-choose-image-box-1 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    {/* Why Choose Image Start */}
                                    <div className="why-choose-image">
                                        <figure>
                                            <img src="./assets/solar/solar_westa_615x327.webp" alt />
                                        </figure>
                                    </div>
                                    {/* Why Choose Image End */}
                                    {/* Why Choose Scrolling Ticker Start */}
                                    <div className="why-choose-scrolling-ticker">
                                        {/* Why Choose Scrolling Box Start */}
                                        <div className="scrolling-ticker-box">
                                            <div className="scrolling-content">
                                                <span>Residential Solar</span>
                                                <span>Solar Installation</span>
                                                <span>Solar Maintenance</span>
                                                <span>Hybrid Solar Systems</span>
                                                <span>Green Energy</span>
                                                <span>Residential Solar</span>
                                                <span>Solar Installation</span>
                                                <span>Solar Maintenance</span>
                                                <span>Hybrid Solar Systems</span>
                                                <span>Green Energy</span>
                                            </div>
                                            <div className="scrolling-content">
                                                <span>Residential Solar</span>
                                                <span>Solar Installation</span>
                                                <span>Solar Maintenance</span>
                                                <span>Hybrid Solar Systems</span>
                                                <span>Green Energy</span>
                                                <span>Residential Solar</span>
                                                <span>Solar Installation</span>
                                                <span>Solar Maintenance</span>
                                                <span>Hybrid Solar Systems</span>
                                                <span>Green Energy</span>
                                            </div>
                                        </div>
                                        {/* Why Choose Scrolling Box End */}
                                    </div>
                                    {/* Why Choose Scrolling Ticker End */}
                                </div>
                                {/* Why Choose Image Box 1 End */}
                                {/* Why Choose Image Box 2 Start */}
                                <div className="why-choose-image-box-2">
                                    {/* Why Choose Image Start */}
                                    <div className="why-choose-image">
                                        <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                                            <img src="./assets/images/why-choose-us-image-2.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                                        </figure>
                                    </div>
                                    {/* Why Choose Image End */}
                                    {/* Why Choose Info Box Start */}
                                    <div className="why-choose-info-box wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                        <div className="why-choose-info-image">
                                            <figure>
                                                <img src="./assets/images/why-choose-info-image.png" alt />
                                            </figure>
                                        </div>
                                        <div className="why-choose-info-content">
                                            <h3>🌞 Powering a Better Tomorrow</h3>
                                            <p style={{textAlign:""}}>With Solar World Enterprises, you're not just investing in solar energy—you're investing in energy independence, long-term savings, and a sustainable future.</p>
                                        </div>
                                    </div>
                                    {/* Why Choose Info Box End */}
                                </div>
                                {/* Why Choose Image Box 2 End */}
                            </div>
                            {/* Why Choose Us Image Box End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ChooseUs